import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { experienceRoles } from '@/mocks/experience';

export default function ExperienceSelector() {
  const [active, setActive] = useState<number | null>(null);

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="选择你的角色"
            title="你想以什么身份，体验九畴云市？"
            subtitle="消费者、云社员、云店长、供应商、县域运营者，五个角色对应五条真实的运营链路。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {experienceRoles.map((r, i) => (
            <button
              key={r.id}
              onClick={() => setActive(i)}
              className={`h-full p-5 rounded-lg border text-left cursor-pointer transition-all ${
                active === i
                  ? 'border-primary-500 bg-primary-50'
                  : 'border-background-200 bg-background-100 hover:border-primary-300'
              }`}
            >
              <div
                className={`w-11 h-11 rounded-lg flex items-center justify-center ${
                  active === i ? 'bg-primary-500' : 'bg-primary-100'
                }`}
              >
                <i className={`${r.icon} ${active === i ? 'text-background-50' : 'text-primary-600'} text-xl`}></i>
              </div>
              <h3 className="mt-3 font-heading font-bold text-foreground-950 text-base">{r.name}</h3>
              <p className="mt-1 text-sm text-foreground-500 leading-relaxed">{r.desc}</p>
            </button>
          ))}
        </div>

        {active !== null && (
          <Reveal>
            <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className={`${experienceRoles[active].icon} text-background-50 text-2xl`}></i>
                </div>
                <h3 className="font-heading font-bold text-xl text-foreground-950">
                  {experienceRoles[active].name} · 体验链路
                </h3>
              </div>

              <div className="mt-8 flex flex-wrap items-center gap-2">
                {experienceRoles[active].steps.map((s, i) => (
                  <div key={s} className="flex items-center gap-2">
                    <div className="px-4 py-2.5 rounded-md bg-background-50 border border-background-200 text-sm font-medium text-foreground-900 whitespace-nowrap">
                      <span className="text-primary-600 font-semibold mr-1.5">{i + 1}.</span>
                      {s}
                    </div>
                    {i < experienceRoles[active].steps.length - 1 && (
                      <i className="ri-arrow-right-line text-primary-500 text-sm"></i>
                    )}
                  </div>
                ))}
              </div>

              <div className="mt-8 flex items-center gap-3">
                <button className="px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600">
                  进入体验
                </button>
                <button
                  onClick={() => setActive(null)}
                  className="px-6 py-3 rounded-md border border-background-200 text-foreground-600 text-sm whitespace-nowrap cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-colors"
                >
                  换个角色
                </button>
              </div>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}